module.exports = __webpack_public_path__ + "img/eco.a798370b.png";